import { FlightModel } from 'api-hooks/tour/tour-list/flight/model';
import classNames from 'classnames';
import { useFormState } from 'components/elements/form';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import FlightTable from '.';
import styles from '../styles.module.css';

interface Props {
  tourFlights?: FlightModel[];
}

export function FlightTab(props: Props) {
  const { t } = useTranslation();
  const { tourFlights: flight } = props;
  const { editable } = useFormState();

  return (
    <div className={classNames(styles.padtb16, styles.fullFlex)}>
      {(!editable && !!flight?.length) || editable ? (
        <FlightTable />
      ) : (
        <>{t('common:no_flight_set_yet')}</>
      )}
    </div>
  );
}
